module.exports = __webpack_public_path__ + "img/samedi-logo-blue.b21cd45d.svg";